import React from 'react'

interface IFilterCheckboxProps {
    id: string
    label: string
    checked: boolean
    onChange: () => void
}

/** Opção de material ou característica do filtro da listagem. */
const FilterCheckbox: React.FC<IFilterCheckboxProps> = ({ id, label, checked, onChange }) => (
    <div className={'form-group flex items-center mb-1'}>
        <input
            type="checkbox"
            name={id}
            id={id}
            className={`checkbox-s appearance-none border border-dark-yellow bg-white h-5 w-5 rounded-md grid place-content-center before:content-[''] before:h-3 before:w-3 before:bg-destaques-hover before:rounded-full before:scale-0 lg:hover:before:bg-light-blue-inactive lg:hover:before:scale-100 checked:before:scale-100`}
            onChange={onChange}
            checked={checked}
        />
        <label htmlFor={id} className="flex select-none items-center justify-between p-0 ml-2 text-primary">
            {label}
        </label>
    </div>
)

export default FilterCheckbox
